import _ from "lodash";
import * as types from "./types";
import httpService from "../_utils/http-service";
import { getAuthHttpConfig, getHttpConfig } from "../_utils/auth-utils";
import { traceEvent, reportError } from "../_utils/analytics-utils";

export const setOrder = order => {
  return { type: types.SET_ORDER, payload: order };
};

export const clearOrder = () => {
  return { type: types.CLEAR_ORDER };
};

const logCreateOrderError = obj => {
  console.log("log create order error.");
};

export const createOrder = (order, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    traceEvent("order", "create");
    _.map(order.customers[0].dishes, dish => {
      delete dish.name;
      delete dish.price;
      delete dish.prices;
    });

    let payload = {
      serviceTypeId: 1,
      restaurantId: order.restaurantId,
      customers: [
        {
          id: order.customers[0].customerId,
          isHost: 1,
          dishes: order.customers[0].dishes
        }
      ]
    };

    if (order.joinToken !== undefined) {
      payload.joinToken = order.joinToken;
    }

    if (payload.customers[0].id !== undefined) {
      httpService
        .post(
          `/customers/${payload.customers[0].id}/order`,
          payload,
          getAuthHttpConfig(storage)
        )
        .then(res => {
          if (res.data.statusCode === 200) {
            const order = res.data.data;
            callback({ success: true, order });
          } else {
            logCreateOrderError({
              description: "Create Normal Order",
              payload,
              httpConfig: getAuthHttpConfig(storage),
              responseData: res.data
            });

            callback({ success: false });
            reportError("createOrder", { res });
          }
        })
        .catch(err => {
          logCreateOrderError({
            description: "Create Normal Order Error",
            payload,
            httpConfig: getAuthHttpConfig(storage),
            err
          });
          reportError("createOrder", { err });
          callback({ success: false });
        });
    } else {
      delete payload.customers[0].id;

      if (storage.customerName === undefined) {
        payload.customers[0].name = "anonymous";
      } else {
        payload.customers[0].name = storage.customerName;
      }

      httpService
        .post(`/customers/order`, payload, getHttpConfig())
        .then(res => {
          if (res.data.statusCode === 200) {
            const order = res.data.data;
            dispatch({
              type: types.SET_ITEM,
              payload: {
                key: "anonymousToken",
                value: order.authorization
              }
            });
            callback({ success: true, order });
          } else {
            logCreateOrderError({
              description: "Create Anonymous Order",
              payload,
              httpConfig: getAuthHttpConfig(storage),
              responseData: res.data
            });

            reportError("createOrder", { res });
            callback({ success: false });
          }
        })
        .catch(err => {
          logCreateOrderError({
            description: "Create Anonymous Order Error",
            payload,
            httpConfig: getAuthHttpConfig(storage),
            err
          });

          reportError("createOrder", { err });
          callback({ success: false });
        });
    }
  };
};

export const removeDish = ({ customerId, orderId, orderDishId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;

    httpService
      .delete(
        `/customers/${customerId}/orders/${orderId}/dishes/${orderDishId}`,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          const order = res.data.data;
          callback({ success: true, order });
        } else {
          traceEvent("error", "removeDish");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "removeDish");
        callback({ success: false });
      });
  };
};

export const addDish = ({ order, dish }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;

    let payload = {
      customerOrderId: order.customers[0].id,
      dish: {
        id: dish.id,
        quantity: dish.quantity,
        specialRequest: dish.specialRequest,
        options: dish.options,
        priceType: dish.priceType
      }
    };
    let customerId = order.customers[0].customerId;
    let orderId = order.id;

    httpService
      .post(
        `/customers/${customerId}/orders/${orderId}/dishes`,
        payload,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true, order: res.data.data });
        } else {
          traceEvent("error", "addDish");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "addDish");
        callback({ success: false });
      });
  };
};

export const updateDish = ({ customerId, orderId, dish }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;

    let payload = {
      orderDishId: dish.id,
      dish: {
        id: dish.dishId,
        quantity: dish.quantity,
        specialRequest: dish.specialRequest,
        options: dish.options,
        priceType: dish.priceType
      }
    };

    httpService
      .put(
        `/customers/${customerId}/orders/${orderId}/dishes`,
        payload,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true, order: res.data.data });
        } else {
          traceEvent("error", "updateDish");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "updateDish");
        callback({ success: false });
      });
  };
};

export const deleteOrder = ({ customerId, orderId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;

    traceEvent("order", "delete");
    httpService
      .delete(
        `/customers/${customerId}/order/${orderId}`,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true });
        } else {
          traceEvent("error", "deleteOrder");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "deleteOrder");
        callback({ success: false });
      });
  };
};

export const cancelOrder = ({ customerId, orderId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    traceEvent("order", "cancel");
    httpService
      .put(
        `/v2/customers/${customerId}/order/${orderId}/cancel`,
        null,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true });
        } else {
          traceEvent("error", "cancelOrder");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "cancelOrder");
        callback({ success: false });
      });
  };
};

export const reorder = ({ customerId, orderId }, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    const url = `/customers/${customerId}/orders/${orderId}/reorder`;
    traceEvent("order", "reorder");
    httpService
      .post(url, null, getAuthHttpConfig(storage))
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true, order: res.data.data });
        } else {
          traceEvent("error", "reorder");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "reorder");
        callback({ success: false });
      });
  };
};

export const rateOrder = ({ order, customerId, rating }, callback) => {
  return function(dispatch, getState) {
    traceEvent("order", "rate");
    const storage = getState().storage;

    httpService
      .post(
        `/customers/${customerId}/restaurants/${order.restaurantId}/orders/${
          order.id
        }/rate`,
        { rating },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true });
        } else {
          traceEvent("error", "rateOrder");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "rateOrder");
        callback({ success: false });
      });
  };
};

export const convertToSoloOrder = ({ orderId, customerId }, callback) => {
  return function(dispatch, getState) {
    traceEvent("order", "convert to solo order");
    const storage = getState().storage;

    httpService
      .put(
        `/customers/${customerId}/order/${orderId}/gng/convertToSolo`,
        null,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true, order: res.data.data });
        } else {
          traceEvent("error", "convertToSoloOrder");
          callback({ success: false });
        }
      })
      .catch(err => {
        traceEvent("error", "convertToSoloOrder");
        callback({ success: false });
      });
  };
};

export const fetchOrderInvite = customerId => {
  return function(dispatch, getState) {
    traceEvent("order", "fetch order invite");
    const storage = getState().storage;

    httpService
      .get(
        `/v2/customers/${customerId}/order/invite`,
        getAuthHttpConfig(storage)
      )
      .then(res => {})
      .catch(err => {});
  };
};

export const acceptOrderInvite = ({ inviteId, customerId }, callback) => {
  return function(dispatch, getState) {
    traceEvent("order", "fetch order invite");
    const storage = getState().storage;

    httpService
      .put(
        `/v2/customers/${customerId}/invites/${inviteId}/response`,
        {
          inviteResponse: "accepted"
        },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true });
        } else {
          callback({ success: false });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};

export const ignoreOrderInvite = ({ inviteId, customerId }, callback) => {
  return function(dispatch, getState) {
    traceEvent("order", "fetch order invite");
    const storage = getState().storage;

    httpService
      .put(
        `/v2/customers/${customerId}/invites/${inviteId}/response`,
        {
          inviteResponse: "rejected"
        },
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({ success: true });
        } else {
          callback({ success: false });
        }
      })
      .catch(err => {
        callback({ success: false });
      });
  };
};
